module.exports = __webpack_public_path__ + "f9eeff6963365c60190cbf890684b16d.svg";